export const messages = {
  en: {
    printOwnerVoting: {
      room: 'Room',
      totalVotes: 'Total votes',
      votedCount: 'Voted count',
      person: 'person'
    }
  },
  zh: {
    printOwnerVoting: {
      room: '房间',
      totalVotes: '投票总数',
      votedCount: '已投票',
      person: '人'
    }
  },
  'zh-TW': {
    printOwnerVoting: {
      room: '房間',
      totalVotes: '投票總數',
      votedCount: '已投票',
      person: '人'
    }
  }
};